import React, {useMemo, useRef, useState} from 'react';
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FaTimes} from "react-icons/fa";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import TruncateCellRenderer from "../../../components/cell-renderer/truncate-cell-renderer";

const LaneModal = ({set, open, data}) => {
    const [columnDefs] = useState([
        {field: "description", headerName: "Sentido", cellRenderer: TruncateCellRenderer},
        {field: "source", headerName: "IP"},
        {field: "driver", headerName: "Driver e firmware"},
        {field: "trigger", headerName: "Gatilho"},
        {field: "type", headerName: "Tipo de dispositivo"},
        {field: "pending", headerName: "Pendentes", valueFormatter: ({value}) => value ?? 0, width: 100},
        {field: "lastPassage", headerName: "Última Passagem", cellRenderer: TruncateCellRenderer},
        {field: "details", headerName: "Detalhes", cellRenderer: TruncateCellRenderer, flex: 1, minWidth: 250},
    ]);

    const gridRef = useRef();

    const rowClassRules = useMemo(() => {
        return {
            "error": ({data: {status}}) => status === "OFFLINE",
            "warning": ({data: {status}}) => status === "WARNING",
            "success": ({data: {status}}) => status === "ONLINE",
        };
    }, []);

    return (
        <Dialog open={open} onClose={set} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-9/12 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="bg-white py-4 border-b border-gray-300">
                            <div className="text-left">
                                <DialogTitle as="h3" className="font-semibold leading-6 border-b border-gray-300 px-3 flex justify-between">
                                    {data.capturePlaceName}
                                    <span onClick={() => set(false)} className="cursor-pointer">
                                        <FaTimes />
                                    </span>
                                </DialogTitle>
                                <div className="mt-4 px-3">
                                    <div className={"ag-theme-quartz grid mt-4"}
                                         style={{height: "calc(100vh - 233px)"}}>
                                        <AgGridReact
                                            ref={gridRef}
                                            rowHeight={32}
                                            rowData={data?.lanes ?? []}
                                            columnDefs={columnDefs}
                                            animateRows={false}
                                            suppressRowClickSelection={true}
                                            suppressCellFocus={true}
                                            rowClassRules={rowClassRules}
                                            gridOptions={{localeText: LocalizationAgGrid}}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};

export default LaneModal;